var _circle, _circle2, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 75,
    viewBox: "0 0 70 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 40,
    r: 35,
    fill: "url(#paint0_linear_1670_304)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 12,
    r: 10.5,
    fill: "#5245C7",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.608 7.76V6.432H11.616V18H10.144V7.76H8.608Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1670_304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3379 49.2426C22.3379 49.0506 22.3379 48.6667 22.3379 48.4472C22.3638 48.1456 22.5193 47.7616 22.5971 47.4599L31.8773 29.3038C33.4067 26.6983 36.7766 26.6983 38.3319 29.3038C41.1574 35.2004 44.5014 40.8502 47.301 46.7468C48.623 49.5169 47.4047 52.2869 44.5014 52.8354H25.6041C23.8932 52.5886 22.4934 51.0527 22.3379 49.2426ZM34.9879 33.8291C34.288 33.884 33.6918 34.4873 33.6141 35.2278V43.4008C33.7696 45.3755 36.3359 45.4029 36.5951 43.5105C36.4396 40.8776 36.8025 37.943 36.5951 35.3375C36.3877 32.7321 35.8175 33.7742 34.9879 33.8565V33.8291ZM34.9879 46.5C33.0178 46.6645 33.2252 49.846 35.2731 49.654C37.3209 49.462 36.9321 46.3354 34.9879 46.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8036 33.0297C35.8926 32.9406 36.8115 33.7124 36.9136 34.6326C37.1858 37.4524 36.7094 40.6285 36.9136 43.478C36.5732 45.5558 33.2042 45.4965 33 43.3593V34.5138C33.1021 33.7421 33.9188 33.0594 34.8377 33L34.8036 33.0297Z",
    fill: "#4645CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1670_304",
    x1: 35,
    y1: 5,
    x2: 35,
    y2: 75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D46C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1542E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1670_304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(22 27)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAlert);
export default __webpack_public_path__ + "static/media/activeAlert.d8f693ff88d47d9b5d7322cfef6c97b1.svg";
export { ForwardRef as ReactComponent };